<div class="ds-grid">
  <div class="row mt-7 mb-6">
    <div class="col-12">
      <h2 *ngIf="componentData$ | async as componentData" class="ds-heading--l text-center">
        {{componentData.headline}}
      </h2>
    </div>
  </div>
  <div class="row mb-6">
    <div class="col">
      <ds-nav
        (activeIdChange)="onNavChangeById($event)"
        [activeNavItem]="activeNavItem"
        [navItems]="navItems"
        [numberOfShownElements]="numberOfShownCategories"
        [showMoreText]="('common.more' | cxTranslate) + ' ' + ('categories.categories' | cxTranslate)"
        class="mx-auto"
        switchToScrollBreakpoint="lg"
      >
      </ds-nav>
    </div>
  </div>
  <div class="product-grid-placeholder">
    <ng-container *ngIf="productSearchPage?.products?.length; else noProductsFound">
      <div class="row tile-row">
        <ng-container *ngFor="let product of productSearchPage.products; let i = index">
          <ng-container *ngIf="i < numberOfShownProducts">
            <div class="col-sm-6 col-lg-4 mb-6 tile-col">
              <dcp-product-tile [product]="product"></dcp-product-tile>
            </div>
          </ng-container>
        </ng-container>
      </div>
      <ng-container
        *ngIf="totalResults > numberOfShownProducts || productSearchPage.products.length > numberOfShownProducts">
        <div *ngIf="activeNavItem" class="col-12 mb-7">
          <button
            (click)="displayProductsOfCategory(activeNavItem.id)"
            class="btn btn-outline-primary d-block my-0 mx-auto"
            data-cy="view-all-popular-apps"
            type="button"
          >
            {{'categories.all' | cxTranslate}} {{'categories.' + activeNavItem.id | cxTranslate}}
          </button>
        </div>
      </ng-container>
      <div class="separator w-100"></div>
    </ng-container>
    <ng-template #noProductsFound>
      <p *ngIf="activeNavItem" class="text-center">
        {{'pageMetaResolver.noProductsFound' | cxTranslate}}
        <em>{{activeNavItem.text | async}}</em>
      </p>
    </ng-template>
  </div>
</div>
